import { Controller } from "@hotwired/stimulus"

// Makes the career path steps list sortable by drag-and-drop. Persists order via PATCH reorder.
export default class extends Controller {
  static targets = ["list"]
  static values = {
    reorderUrl: String
  }

  connect() {
    this.draggedItem = null
    if (!this.hasListTarget) return
    this.list = this.listTarget
    this.items = this.list.querySelectorAll("[data-step-id]")
    this.items.forEach((item) => this.attachDragListeners(item))
  }

  attachDragListeners(item) {
    item.setAttribute("draggable", "true")
    item.addEventListener("dragstart", this.dragStart.bind(this))
    item.addEventListener("dragend", this.dragEnd.bind(this))
    item.addEventListener("dragover", this.dragOver.bind(this))
    item.addEventListener("drop", this.drop.bind(this))
    item.addEventListener("dragenter", this.dragEnter.bind(this))
    item.addEventListener("dragleave", this.dragLeave.bind(this))
  }

  dragStart(event) {
    this.draggedItem = event.currentTarget
    this.draggedItem.classList.add("opacity-50", "cursor-grabbing")
    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.setData("text/plain", this.draggedItem.dataset.stepId)
    event.dataTransfer.setData("application/json", JSON.stringify({ stepId: this.draggedItem.dataset.stepId }))
  }

  dragEnd(event) {
    event.currentTarget.classList.remove("opacity-50", "cursor-grabbing")
    this.list.querySelectorAll("[data-step-id].ring-2").forEach((el) => el.classList.remove("ring-2", "ring-primary", "ring-inset"))
    this.draggedItem = null
  }

  dragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"
  }

  dragEnter(event) {
    if (!this.draggedItem || event.currentTarget === this.draggedItem) return
    event.currentTarget.classList.add("ring-2", "ring-primary", "ring-inset")
  }

  dragLeave(event) {
    event.currentTarget.classList.remove("ring-2", "ring-primary", "ring-inset")
  }

  drop(event) {
    event.preventDefault()
    event.stopPropagation()
    const dropTarget = event.currentTarget
    dropTarget.classList.remove("ring-2", "ring-primary", "ring-inset")
    if (!this.draggedItem || dropTarget === this.draggedItem) return

    const allItems = [...this.list.querySelectorAll("[data-step-id]")]
    const draggedIndex = allItems.indexOf(this.draggedItem)
    const dropIndex = allItems.indexOf(dropTarget)
    if (draggedIndex === -1 || dropIndex === -1) return

    if (draggedIndex < dropIndex) {
      dropTarget.parentNode.insertBefore(this.draggedItem, dropTarget.nextSibling)
    } else {
      dropTarget.parentNode.insertBefore(this.draggedItem, dropTarget)
    }

    this.updateStepNumbers()
    this.persistOrder()
  }

  updateStepNumbers() {
    const items = this.list.querySelectorAll("[data-step-id]")
    items.forEach((item, index) => {
      const numberEl = item.querySelector(".career-step-number")
      if (numberEl) numberEl.textContent = index + 1
    })
  }

  async persistOrder() {
    const stepIds = [...this.list.querySelectorAll("[data-step-id]")].map((el) => el.dataset.stepId)
    if (stepIds.length === 0) return

    const csrfToken = document.querySelector("[name='csrf-token']")?.getAttribute("content")
    const response = await fetch(this.reorderUrlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        Accept: "application/json"
      },
      body: JSON.stringify({ step_ids: stepIds })
    })

    if (!response.ok) {
      console.error("Failed to reorder steps", response)
    }
  }
}
